import { ApiService } from './api.service';
import { SchoolGroupDetail } from '@/models/school-group/school-group-detail';
import { Empty } from '@/models/core/empty';

class SchoolGroupDetailService extends ApiService {
  constructor() {
    super();
  }

  getSchoolGroupDetail(groupID: number): Promise<SchoolGroupDetail> {
    return this.get(SchoolGroupDetail, `/schoolGroups/${groupID}`, {});
  }

  updateSchoolGroupDetail(groupID: number, data: object): Promise<SchoolGroupDetail> {
    return this.put(SchoolGroupDetail, `/schoolGroups/${groupID}`, data);
  }

  downloadProgress(groupID: number): Promise<Blob> {
    return this.downloadFile(`/schoolGroups/${groupID}/download`, {});
  }

  deleteSchoolGroup(groupID: number): Promise<Empty> {
    return this.delete(`/schoolGroups/${groupID}`, {});
  }
}

export const schoolGroupDetailService = new SchoolGroupDetailService();
